<!--
  Canonical *Styles.vue reference.

  A standalone .css keeps a non-.vue module id → vitalizer leaves its <link> → browser
  downloads rules already inlined. SFC <style> gets a .vue id, so the link is stripped.

  Blade-shared sheets: @import into <style> (postcss inlines before the module graph).
  One Vue importer only — a second inlines again rather than sharing.
  Not <style src="...">: that keeps the .css module id, so the <link> survives.
-->

<template />

<style lang="postcss">
.p-chip {
  @apply inline-flex items-center rounded-2xl bg-surface-100 px-3 py-2 text-surface-800 gap-2;

  &-icon {
    @apply h-4 w-4 text-base text-surface-800;
  }

  &-image {
    @apply -ms-2 h-8 w-8 rounded-full;
  }

  &:has(.p-chip-remove-icon) {
    @apply pe-2;
  }

  &:has(.p-chip-image) {
    @apply pb-1 pt-1;
  }

  &-remove-icon {
    @apply h-4 w-4 cursor-pointer rounded-full text-base text-surface-800 focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-primary;
  }
}
</style>
